import React from 'react';

export interface BadgeProps {
  /** Badge content (usually a number) */
  children: React.ReactNode;
  /** Badge variant */
  variant?: 'default' | 'primary' | 'secondary';
  /** Additional CSS classes */
  className?: string;
}

/**
 * Badge component from AgroBook design system
 *
 * Used for count indicators and status badges
 */
export const Badge: React.FC<BadgeProps> = ({
  children,
  variant = 'default',
  className = '',
}) => {
  const baseStyles = 'inline-block rounded-full px-2.5 py-0.5 text-xs font-bold';

  const variantStyles = {
    default: 'bg-green-200 text-green-900',
    primary: 'bg-green-800 text-white',
    secondary: 'bg-gray-200 text-gray-700',
  };

  return (
    <span className={`${baseStyles} ${variantStyles[variant]} ${className}`}>
      {children}
    </span>
  );
};
